import { render, staticRenderFns } from "./role_member.vue?vue&type=template&id=7a85f0ee&scoped=true&"
import script from "./role_member.vue?vue&type=script&lang=js&"
export * from "./role_member.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a85f0ee",
  null
  
)

export default component.exports